// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"5015cbc3","222":"de6b1748","302":"608b1807","369":"8ca24b0f","389":"e33593b7","920":"e2256010"}[chunkId] + ".chunk.js";
};